type VerbaloreMarkProps = {
  className?: string;
  title?: string;
};

export function VerbaloreMark({ className, title }: VerbaloreMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <rect width="64" height="64" rx="14" fill="#173f36" />
      <path
        d="M12 18 21 13 32 41 43 13 52 18 33.5 55 30.5 55Z"
        fill="#f3f0e7"
      />
    </svg>
  );
}
